import React from "react";

const Footer = function () {
  return (
    <div className="text-center mt-3 py-5 w-100" style={{ backgroundColor: "#2d2d2d", color: "white" }}>
      <p className="lead">For help and support please contact us on</p>
      <p className="">
        Tel: <span className="fw-bold">020 4614 2422</span> or email:{" "}
        <span className="fw-bold">eng@boxheat.co.uk</span>
      </p>
    </div>
  );
};

export default Footer;
